module.exports = __webpack_public_path__ + "static/media/grocery-main-page-main-banner.37daeb48.png";